export enum BodyStyleSlug {
  SEDAN = 'bodystyle-sedan',
  HATCHBACK = 'bodystyle-hatchback',
  SPORT = 'bodystyle-sport',
  COUPE = 'bodystyle-coupe',
  MPV = 'bodystyle-mpv',
  SUV = 'bodystyle-suv',
  VAN = 'bodystyle-van',
}
